module.exports = __webpack_public_path__ + "static/media/AeroCapture.0d4d77bf.svg";